
export function sharedMethod() {
    /*
    let useragent = navigator.userAgent;
    let l_useragent = useragent.toLowerCase();

    let Devices = ['android', 'iphone', 'ipad', 'ipod', 'ios'];
    let Devices_len = Devices.length;

    for (let i = 0; i < Devices_len; i++) {
        if (l_useragent.indexOf(Devices[i]) != -1) {
            this.isMobile = true;
            break;
        }
    }
    */
    /*
    //
    let useragent = navigator.userAgent;
    let lc_useragent = useragent.toLowerCase();
    let regex1 = /(?=.*android)(?=.*wv)/i;
    let regex2 = /(?=.*webview.*(?:iphone|ipad|ipod|ios))/i;
    if (Boolean(lc_useragent.match(regex1))) {
        this.isMobile = true;
        this.showFooter = false;
    }
    if (Boolean(lc_useragent.match(regex2))) {
        this.isMobile = true;
        this.showFooter = false;
    }
    */

    //
    let isMobile = false;
    let useragent = navigator.userAgent;
    console.log(useragent);
    let lc_useragent = useragent.toLowerCase();

    let regex1 = /(?=.*android)(?=.*wv)/i;
    let regex2 = /(?=.*KloudHotelApp)/i;
    if (Boolean(lc_useragent.match(regex1))) {
        isMobile = true;
    }
    if (Boolean(lc_useragent.match(regex2))) {
        isMobile = true;
    }

    return isMobile;
}